import React, { useRef, useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import { AIRQUALITY_CHART_COLORS } from './config';
export const AirQualityPieGraph = ({ translationData, data, metric, isExport, fileName, imageWidth, imageHeight }) => {
    const getPieData = data => {
        return (data &&
            data.map(each => {
                return { name: each.name, y: each.percentage, columnValue: each.columnTotal };
            }));
    };
    const chartRef = useRef(null);
    const chartOptions = {
        title: {
            text: '',
        },
        series: [
            {
                data: getPieData(data),
                keys: ['y', 'name'],
                type: 'pie',
                dataLabels: true,
                showInLegend: true,
            },
        ],
        yAxis: {
            title: {
                text: translationData.yAxisTitle,
            },
        },
        colors: AIRQUALITY_CHART_COLORS,
        legend: {
            align: 'center',
            verticalAlign: 'top',
            layout: 'horizontal',
        },
        tooltip: {
            pointFormat: `<b>{point.percentage:.1f}%</b> <br/>{point.columnValue:,.1f} ${metric}`,
        },
        exporting: {
            enabled: false,
            filename: fileName,
            sourceWidth: imageWidth,
            sourceHeight: imageHeight,
        },
        credits: {
            enabled: false,
        },
    };
    const exportChart = () => {
        // @ts-ignore
        chartRef.current.chart.exportChart();
    };
    useEffect(() => {
        if (isExport) {
            exportChart();
        }
    }, [isExport]);
    return (React.createElement(HighchartsReact, { containerProps: { style: { height: "100%" } }, highcharts: Exporting(Highcharts), constructorType: 'chart', options: chartOptions, ref: chartRef }));
};
//# sourceMappingURL=AirQualityPieGraph.js.map